import Vue from 'vue';
import Vuex from 'vuex';
import loginState from './modules/login';
import quoteState from './modules/search';
import checkout from './modules/checkout';
import buttonState from './modules/button';
import helpTextState from './modules/helptext';
import commonState from './modules/quote';
import annualCalc from './modules/annualcalc';
import importUsers from './modules/importUsers';
import updatePageData from './modules/updatePageData';
import creditCardData from './modules/creditCardData';
import user from './modules/user';
import alerts from './modules/alerts';
import admin from './modules/admin';
import homeNav from './modules/homeNav';
import navbuttonsData from './modules/navbuttonsData';
// import axios from './axios-config'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    mutatable_data: {}, // Store entire API response
    first_error: null, // Track the first field-level error in each view
  },
  modules: {
    loginState,
    quoteState,
    checkout,
    buttonState,
    helpTextState,
    commonState,
    annualCalc,
    importUsers,
    updatePageData,
    user,
    alerts,
    admin,
    creditCardData,
    homeNav,
    navbuttonsData,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js